<template>
    <DCard>
        <DTable
            :fields="fields"
            :items="certificateProviders"
        >
            <template #type="{item}">
                <td class="width">
                    <a
                        href="#"
                        @click.prevent="edit(item)"
                    >{{ item.type }}</a>
                </td>
            </template>
            <template #actions="{item}">
                <td class="width text-right">
                    <div class="actions">
                        <DButton
                            icon="pencil"
                            mini
                            @click="edit(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>

    <DFabs>
        <DFab
            icon="plus"
            :label="$t('settings_certificate_providers.add_provider')"
            @click="add()"
        />
    </DFabs>
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { computed, getCurrentInstance } from 'vue'

const { proxy } = getCurrentInstance()

defineProps({
    certificateProviders: {
        type: Array,
        default: () => { return [] }
    }
})

const fields = computed(() => [
    { key: 'type', label: proxy.$t('settings_certificate_providers.type') },
    { key: 'uri', label: proxy.$t('settings_certificate_providers.uri') },
    { key: 'user', label: proxy.$t('settings_certificate_providers.table_user') },
    { key: 'actions', label: '' }
])

const edit = function (item) {
    router.get(route('settings.certificate-providers.edit', { certificate_provider: item.id }))
}

const add = function () {
    router.get(route('settings.certificate-providers.create'))
}
</script>
